<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="CostCenter"
  pathPreFix="HRM"
  [saveLabel]="'ساخت فایل'"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <div style="margin-top: 8px" class="fcContent row" *ngIf="isOk === true">
    <div class="col">
      <ssg-select
        name="EmploymentKindIds"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-md"
        dropdownPosition="auto"
        limitSelection="5"
        [hasCheckBox]="true"
        [hasSelectAll]="true"
        label="نوع استخدام"
        apiName="EmploymentKind/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="col">
      <ssg-select
        name="HrmBankIds"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-md"
        dropdownPosition="auto"
        limitSelection="5"
        [hasCheckBox]="true"
        [hasSelectAll]="true"
        label="محل پرداخت"
        apiName="HrmBank/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="col">
      <ssg-select
        name="OrganizationalUnitIds"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-md"
        dropdownPosition="auto"
        limitSelection="5"
        [hasCheckBox]="true"
        [hasSelectAll]="true"
        label="واحد سازمانی"
        apiName="OrganizationalUnit/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="col">
      <ssg-select
        name="WorkplaceIds"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-md"
        dropdownPosition="auto"
        limitSelection="5"
        [hasCheckBox]="true"
        [hasSelectAll]="true"
        label="محل خدمت"
        apiName="Workplace/ReadLookUp"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
    </div>
    <div class="col">
      <ssg-select
        name="TaxPayCompaniesIds"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-md"
        dropdownPosition="auto"
        limitSelection="5"
        [hasCheckBox]="true"
        [hasSelectAll]="true"
        label="حوزه مالیاتی"
        apiName="PayCompanies/GetPayCompaniesTaxBranchs"
        textFieldName="DisplayName"
        valueFieldName="PayCompaniesId">
      </ssg-select>
    </div>
    <div class="col">
      <ssg-select
        name="InsPayCompaniesIds"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-md"
        dropdownPosition="auto"
        limitSelection="5"
        [hasCheckBox]="true"
        [hasSelectAll]="true"
        label="شعبه بیمه"
        apiName="PayCompanies/GetPayCompaniesInsuranceBranchs"
        textFieldName="DisplayName"
        valueFieldName="PayCompaniesId">
      </ssg-select>
    </div>
  </div>
</dynamic-form>
